import styled from 'styled-components';

const SubMegaMenuContainer = styled.div`
  padding: ${props => `30px 10px ${props.hasSeeAllElement ? '70px' : '30px'} 0`};
  flex: ${({ isProProducts }) => (isProProducts ? '0.9' : '1')};
  max-height: ${({ isMenuOpened }) => (isMenuOpened ? '3000px' : 'inherit')};

  .sub-mega-menu--title {
    font-family: Sofia Pro;
    font-size: 14px;
    font-weight: 600;
    line-height: 33px;
    letter-spacing: 0.04em;
    color: var(--neutral-7);
    opacity: 1;
    text-transform: uppercase;
  }

  .sub-mega-menu--content {
    list-style: none;
    margin: 0 10px 0 -10px;
    padding: 20px 0 0;

    .ant-row {
      margin: -16px -4px 16px;
    }

    .mega-menu-item {
      vertical-align: middle;
      padding: 10px;

      &:hover {
        background: var(--blue-fourth);
      }

      a {
        display: flex;
        justify-content: flex-start;

        .mega-menu-item--icon {
          border: none;
          width: 40px;
          height: 40px;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .mega-menu-item--content {
          padding: 0 0 0 10px;
          align-self: center;

          .mega-menu-item--title {
            font-family: Sofia Pro;
            font-size: 16px;
            line-height: 24px;
            color: var(--normal-title-color);
            margin: 0;
            padding: 0;
          }

          .mega-menu-item--description {
            font-family: Sofia Pro;
            font-size: 15px;
            line-height: 21px;
            color: #71848c;
            margin: 0 0 15px 0;
            display: none;
          }
        }
      }
    }
  }

  &.sub-mega-menu-footer {
    padding: 30px 10px 30px 40px;
    background: #36363a;
    z-index: 1;

    .sub-mega-menu--title {
      color: var(--white-color);
    }

    .sub-mega-menu--content {
      .mega-menu-item {
        &:hover {
          background: transparent;
        }

        a {
          .mega-menu-item--title {
            color: var(--white-color);
          }

          &:hover {
            .mega-menu-item--content {
              .mega-menu-item--title {
                color: var(--neutral-text-color);
              }
            }
          }
        }
      }

      .mega-menu-item {
        a {
          .mega-menu-item--icon {
            background: #c4c4c4;
            border-radius: 50%;
          }
        }
      }
    }
  }

  @media (max-width: 1240px) {
    .sub-mega-menu--content {
      .mega-menu-item {
        width: 100%;

        &:hover {
          background: transparent;

          .mega-menu-item--content {
            .mega-menu-item--title {
              color: var(--neutral-text-color);
            }
          }
        }
      }
    }
  }

  @media (min-width: 992px) {
    .sub-mega-menu--content .ant-row .ant-col-lg-6 {
      clear: none;
    }

    .sub-mega-menu--content .ant-row .ant-col-lg-6:nth-child(4n + 1) {
      clear: left;
    }
  }
`;

export { SubMegaMenuContainer };
